export default {
  sendARescheduleRequest: '/rescheduleRequest/sendRequest',
  cancelAPendingRescheduleRequest: '/rescheduleRequest/cancelAPendingRequest',
  getReceivedRescheduleRequests: '/rescheduleRequest/getReceivedRescheduleRequests',
  getSentRescheduleRequests: '/rescheduleRequest/getSentRescheduleRequests',
  acceptOrRejectARescheduleRequest: '/rescheduleRequest/acceptOrRejectRequest'
}
